import React from 'react';
import styles from './Privacy_policy.module.css'; // optional CSS module
import { ServiceDetails } from "../../Services/ServiceDetails";


const TermsAndConditions = () => {
  return (
    <div >
      <div className="row g-0">
        <ServiceDetails />
        <div className={styles.privacyContainer}>
          <div className="row g-0 align-items-center">
            <div className='col-md-12 terms'>
              <section class="site-section terms mt-5">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 text-start terms">
                      <h2>Information We Collect:</h2>
                      <p>We may collect the following types of information:</p>
                      <p><b>Personal Information:</b> Your name, contact details, PAN, Aadhaar (if voluntarily provided), income, bank details, etc., necessary to process loan applications.</p>
                      <p><b>Credit Information: </b>Your credit report and score for loan eligibility assessment, accessed with your consent via TransUnion CIBIL or other bureaus.</p>
                      <p><b>Device and Usage Data: </b>IP address, device ID, browser type, and usage behavior on our website/app.</p>
                      <p><b>IP address, device ID, browser type, and usage behavior on our website/app.</b></p>
                     
                      <h2>Principles for Processing Personal Data:</h2>
                      <p>We collect and process your data based on these principles: Lawfulness, fairness, and transparency.</p>
                      <p><b>Purpose limitation:</b> Only for specific, lawful loan-related and compliance activities Data minimization and accuracy Integrity and confidentiality of information using appropriate security controls.</p>
                      <h2>How We Process Personal Data:</h2>
                      <p>Your data is collected and processed through:</p>
                      <p><b>Our website and secure online forms</b></p>
                      <p><b>Our mobile application</b></p>
                      <p><b>Third-party integrations (credit bureaus, KYC providers)</b></p>
                      <p><b>Document uploads via digital and offline channels</b></p>
                      <p><b>All channels are secured with encryption and access controls.</b></p>
                      <p><b>By submitting our web form, you agree to receive promotional calls on the number shared, and such calls and SMS would be coming from a third-party platform.</b></p>

                      <h2>Legal Basis for Processing:</h2>
                      <p>We process your personal data based on:</p>
                      <p>Your consent (e.g., for credit report access)</p>
                      <p>Contractual necessity (e.g., to process your loan application)</p>
                      <p>Legal obligations (e.g., KYC norms, reporting to regulators)</p>
                      <p>Legitimate interest (e.g., fraud prevention, product improvement)</p>
                      
                      <h2>Accuracy and Completeness of Data:</h2>
                      <p>We rely on the data provided by you. You are responsible for ensuring it is accurate and complete. You can request corrections by contacting our support or grievance redressal team.</p>
                      <h2>Your Rights:</h2>
                      <p>You have the right to:</p>
                      <p>Access your data</p>
                      <p>Request corrections to inaccurate or incomplete data</p>
                      <p>Request corrections to inaccurate or incomplete data</p>
                      <p>Opt out of promotional messages</p>
                      <p>Request deletion or portability of your data</p>
                      <p>Your continued use of our services after updates implies consent to the revised policy. You may withdraw consent if changes are unacceptable.</p>
                      <h2>Retention of Personal Data:</h2>
                      <p>Credit Bureau data (e.g., CIBIL reports) is retained for up to 6 months or until no longer needed, whichever is earlier Other personal data is retained only as long as necessary for legal, regulatory, or operational reasons Data is securely deleted or anonymized after retention limits are met.</p>
                      <h2>Information Sharing:</h2>
                      <p>We may share your data only with:</p>
                      <p>RBI-registered banks and NBFCs for loan processing</p>
                      <p>Third-party service providers (e.g., for credit checks, KYC, document verification) under strict confidentiality.</p>
                      <p>Regulatory or legal authorities where required by applicable law</p>
                      <p>We do not sell your personal data. All sharing complies with applicable laws and uses secure channels.</p>
                      
                      <h2>Lending Partners:</h2>
                      <p>We work with multiple RBI-registered lending institutions. You can find the latest list of our partners at: <a herf="https://www.ruloans.com/our-lending-partners" target='_blank'>Lending Partners</a></p>
                      <h2>Cookies and Tracking</h2>
                      <p>We use cookies and similar technologies for:</p>
                      <p>Session management, Analytics, Improving user experience</p>
                      <p>You may disable cookies through your browser settings, though some features may be affected.</p>
                      <h2>Application of Data Privacy Laws</h2>
                      <p>This policy complies with:</p>
                      <p>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 (India)</p>
                      <p>Digital Personal Data Protection Act, 2023 (India)</p>
                      <p>All disputes are subject to the jurisdiction of courts in Mumbai, India.</p>
                      
                      <h2>Children's Privacy:</h2>
                      <p>Our services are not meant for users under 18. If such data is collected unintentionally, it will be deleted promptly upon discovery.</p>
                      <h2>Grievance Redressal:</h2>
                      <p>For complaints or concerns, contact our Grievance Redressal Officer:</p>
                      <p><b>Email:</b> grievance@dealsofarya.com</p>
                      <p><b>Phone:</b> +91-7030962626</p>
                      <p><b>Address:</b> Deals of Arya, Flat no 18, Kishor kunj, 2nd floor, Old Sbi Colony, Pir bajar road, Osmanpura, Chatrapati Sambhajinagar, Bhajivalibai Chowk, Maharashtra, 431001.</p>
                      <p>For general support:</p>
                      <p><b>Email: </b>support@dealsofarya.com</p>
                      <h2>Updates to This Privacy Policy:</h2>
                      <p>This policy may be updated periodically.</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
